import { useEffect } from 'react';
import './App.css';
import { ThemeProvider } from './context/ThemeContext';
import Header from './Components/Header/Header';
import Home from './Components/Home/Home';
import About from './Components/About/About';
import Skills from './Components/Skills/Skills';
import Qualification from './Components/Qualification/Qualification';
import Contact from './Components/Contact/Contact'
import Footer from './Components/Footer/Footer'
import Portfolio from './Components/Portfolio/Project'
import ScrollButton from './Components/ScrollButton/ScrollButton';
import ThemeToggle from './Components/ThemeToggle/ThemeToggle';
import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);
  
  return (
    <ThemeProvider>
      <ThemeToggle />
      <Header/>
      <main className='main'>
        <Home/>
        <About/>
        <Skills/>
        <Qualification/>
        <Portfolio/>
        <Contact/>
      </main>
      <ScrollButton />
      <Footer/>
    </ThemeProvider>
  );
}

export default App;
